import { TABLE_BORDER_WIDTH } from "components/bootstrap/Table";
import { DEFAULT_COL_WIDTH, ACTIONS_COL_ID, BULK_SELECT_COL_ID } from "components/common/EntityDataTable/Constants";
const resolveColumnWidth = ({
  columnRenderer,
  columnWidthPreference,
  headerMinWidth
}) => {
  var _a;
  const width = (_a = columnWidthPreference != null ? columnWidthPreference : columnRenderer == null ? void 0 : columnRenderer.staticWidth) != null ? _a : DEFAULT_COL_WIDTH;
  if (width === "matchHeader") {
    return headerMinWidth != null ? headerMinWidth : DEFAULT_COL_WIDTH;
  }
  return Math.max(width, headerMinWidth != null ? headerMinWidth : 0);
};
const calculateColumnWidths = ({
  actionsColMinWidth,
  attributeColumnIds,
  attributeColumnRenderers,
  bulkSelectColWidth,
  columnWidthPreferences,
  headerMinWidths,
  scrollContainerWidth
}) => {
  const attributeColumnWidths = Object.fromEntries(
    attributeColumnIds.map((id) => [
      id,
      resolveColumnWidth({
        columnRenderer: attributeColumnRenderers[id],
        columnWidthPreference: columnWidthPreferences == null ? void 0 : columnWidthPreferences[id],
        headerMinWidth: headerMinWidths[id]
      })
    ])
  );
  const attributeColumnsWidth = Object.values(attributeColumnWidths).reduce((total, width) => total + width, 0);
  const remainingWidth = scrollContainerWidth - TABLE_BORDER_WIDTH - bulkSelectColWidth - attributeColumnsWidth;
  return {
    ...attributeColumnWidths,
    // The actions column is the elastic tail. It fills the remaining space, so the table spans the container.
    [ACTIONS_COL_ID]: Math.max(actionsColMinWidth, remainingWidth),
    ...bulkSelectColWidth ? { [BULK_SELECT_COL_ID]: bulkSelectColWidth } : {}
  };
};
const useColumnWidths = ({
  actionsColMinWidth,
  bulkSelectColWidth,
  columnRenderersByAttribute,
  columnIds,
  scrollContainerWidth,
  columnWidthPreferences,
  headerMinWidths
}) => {
  if (!scrollContainerWidth) {
    return {};
  }
  return calculateColumnWidths({
    actionsColMinWidth,
    attributeColumnIds: columnIds,
    attributeColumnRenderers: columnRenderersByAttribute,
    bulkSelectColWidth,
    columnWidthPreferences,
    headerMinWidths,
    scrollContainerWidth
  });
};
export default useColumnWidths;
